<template>
  <div class="upgrade-dialog">
    <ImagePreviewer
      v-for="item in previewList"
      :key="item.previewKey"
      :currentImage="item.largeImage"
      :imageList="item.largeImageArray"
      @close="closePreview(item)"
    />
  </div>
</template>
<script>
import { MessageBox } from "element-ui";
import { Dialog } from "vant";
import { getPlatform } from "@tencentcloud/universal-api";
// 导入轮询管理器和错误处理器
import { startVersionCheck } from '@/utils/worker/manager';
import ImagePreviewer from "@/TUIKit/components/common/ImagePreviewer/index.vue";

export default {
  components: {
    ImagePreviewer
  },
  data() {
    return {
      isPC: getPlatform() === "pc",
      versionUnsub: null
    };
  },
  computed: {
    previewList() {
      return this.$store.getters["draft/getPreviewList"];
    }
  },
  mounted() {
    console.log('this.$store',this.$store)
    this.checkUpgrade();
    this.isPC && this.checkChromeAgent()
  },
  beforeDestroy() {
    if(this.versionUnsub) {
      this.versionUnsub();
      this.versionUnsub = null
    }
  },
  methods: {
    closePreview(it) {
      this.$store.commit("draft/setPreviewList", this.previewList.filter(item => it.previewKey !== item.previewKey));
    },
    checkUpgrade() {
      console.log(
        "当前版本",
        process.env.VUE_APP_ENV,
        process.env.VUE_APP_BUILD_TIME_VERSION
      );
      if (process.env.VUE_APP_ENV != "development") {
        const docUrl = window.location.origin + window.location.pathname;
        const url = (docUrl.endsWith('/') ? docUrl : docUrl + '/') + 'version.json';
        this.versionUnsub = startVersionCheck({
          url,
          version: process.env.VUE_APP_BUILD_TIME_VERSION,
          interval: 10000
        }, (err, data) => {
          if (data?.newVersion) {
            this.openUpgrade(data?.newVersion, data?.oldVersion);
          }
        })
      } else {
        // this.openUpgrade();
      }
    },
    openUpgrade(newVersion, oldVersion) {
      const content = "检测到有新版本更新，请重新刷新页面后使用";
      const confirmButtonText = "刷新页面";
      this.$tracker.send({
        message: '#版本升级提醒#',
        content: {
          newVersion, oldVersion
        },
      })
      const callback = () => {
        window.location.reload();
      };
      const h = this.$createElement;
      this.isPC
        ? MessageBox({
            confirmButtonText,
            confirmButtonClass: "upgrade-dialog-pc-btn",
            showClose: false,
            customClass: "upgrade-dialog-pc",
            closeOnPressEscape: false,
            closeOnClickModal: false,
            message: h("div", [
              h(
                "div",
                {
                  style:
                    "margin-top:5px;display:flex;align-items:center;font-size: 16px;font-weight: 600;",
                },
                [
                  h("i", {
                    class: "el-icon-warning-outline",
                    style: "margin-right:3px;color: #14A0E6;font-size: 20px;",
                  }),
                  "提示",
                ]
              ),
              h(
                "div",
                {
                  style:
                    "background: #EFEFEF;height:1px;margin: 17px 0 24px 0;",
                },
                ""
              ),
              h(
                "div",
                {
                  style:
                    "font-size: 14px;line-height: 22px;color: #333333;font-weight: 400;margin-bottom: 14px;",
                },
                content
              ),
            ]),
          }).then(callback)
        : Dialog.alert({
            title: "温馨提示",
            message: content,
            confirmButtonText,
            confirmButtonColor: "#14A0E6",
            showClose: false,
            className: "upgrade-dialog-h5",
          }).then(callback);
    },
    // 验证当前是否是PC chrome浏览器，再添加一个逻辑如果当天已经提示过就不再提示
    checkChromeAgent() {
      const userAgent = navigator.userAgent;
      const isChrome = /Chrome/.test(userAgent) && 
                   !/Edg/.test(userAgent) && 
                   !/OPR/.test(userAgent);
      const shouldShowAlert = this.isPC && !isChrome; // 是 PC 但不是 Chrome

      // 1. 如果不是 Chrome 且是 PC，才需要提示
      if (shouldShowAlert) {
        // 2. 检查当天是否已提示过（使用 localStorage）
        const today = new Date().toLocaleDateString(); // 如 "2025/12/19"
        const lastAlertDate = localStorage.getItem('chromeHosAlertDate');

        if (lastAlertDate !== today) {
          this.$message({
            message: '爱连健康医生PC端仅兼容Chrome浏览器，为保证更好的产品体验，请使用Chrome浏览器  ',
            type: 'error',
            duration: 0,
            showClose: true,
            customClass: 'checkChromeAgent',
            onClose: () => {
              // 3. 关闭时记录当天已提示
              localStorage.setItem('chromeHosAlertDate', today);
            }
          });
        }
      }
    }

  },
};
</script>
<style lang="scss">
.upgrade-dialog-h5 {
  width: 270px !important;
  .van-dialog__header {
    font-size: 17px;
  }
  .van-dialog__content {
    padding: 0 13px;
  }
  .van-dialog__message {
    font-size: 15px;
    line-height: 22px;
    padding-top: 11px;
    padding-bottom: 18px;
  }
}
.upgrade-dialog-pc {
  width: 500px !important;
  padding-bottom: 16px !important;
  border-radius: 10px !important;
  &-btn {
    background: #14A0E6 !important;
    color: #fff !important;
    border-radius: 20px !important;
    padding: 0 20px !important;
    height: 36px !important;
    line-height: 20px !important;
    font-size: 14px !important;
    font-weight: 600 !important;
  }
}
.checkChromeAgent{
  white-space: nowrap;
  .el-message__icon {
    display: none;
  }
  .el-message__content {
    margin-right: 10px;
  }
  .el-icon-close{
    color: #F56C6C;
    &::before{
      content: "\e79d";
    }
    &:hover {
      color: #fe8686;
    }
  }
}
</style>
